import dayjs from '@utils//dayjs'

export const formatNumber = (amount?: number) =>
  amount !== undefined ? Intl.NumberFormat('th', { maximumFractionDigits: 2 }).format(amount) : '-'

export const formatDate = (iso: string | undefined, format = 'D MMM BBBB') => (iso ? dayjs(iso).format(format) : '-')

export const atLeast = (value: number, least = 0) => (value < least ? least : value)
